import { store } from '@core/Store'
import { BetResponseCode } from '@core/Data/betting'
import { KambiPlaceBetResponse, KambiPlaceSingleBetRequest } from './types'
import { selectPlayerSessionId } from '../Store/selectors'

export function placeKambiBetSingle(
  request: KambiPlaceSingleBetRequest
): Promise<KambiPlaceBetResponse> {
  const playerSessionId = selectPlayerSessionId(store.getState())

  return fetch(
    `${window._kc.apiPlayerBaseUrl}coupon.json?lang=en_AU&market=AU&client_id=2&channel_id=3`,
    {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${playerSessionId}`,
      },
      body: JSON.stringify(request),
    }
  )
    .then(response => response.json() as Promise<KambiPlaceBetResponse>)
    .catch(() => {
      throw {
        code: BetResponseCode.NetworkError,
        response: {
          message: 'Network Error',
        },
      }
    })
}
